
const CertificationGrid = () => {
  const certifications = [
    {
      id: 1,
      title: '有机产品认证证书',
      issuer: '中国质量认证中心',
      date: '2024年3月',
      image: 'https://public.readdy.ai/ai/img_res/56ee82f4465e150435fea7fec51178b9.jpg',
      description: '通过国家有机茶园标准认证，确保茶叶生产全程无农药、无化肥',
      icon: 'ri-plant-line',
      color: 'text-green-600'
    },
    {
      id: 2,
      title: '中央政府采购供应商',
      issuer: '中央政府采购中心',
      date: '2023年12月',
      image: 'https://readdy.ai/api/search-image?query=Government%20procurement%20supplier%20certificate%20with%20official%20red%20seal%2C%20Chinese%20national%20emblem%2C%20formal%20document%20layout%20with%20gold%20borders%2C%20traditional%20Chinese%20calligraphy%20elements%2C%20professional%20government%20style&width=300&height=400&seq=cert-government&orientation=portrait',
      description: '获得中央政府采购供应商资格，品质获得国家级认可',
      icon: 'ri-government-line',
      color: 'text-red-600'
    },
    {
      id: 3,
      title: 'ISO22000食品安全认证',
      issuer: '国际标准化组织',
      date: '2024年1月',
      image: 'https://readdy.ai/api/search-image?query=ISO%2022000%20food%20safety%20management%20certificate%20with%20blue%20and%20white%20design%2C%20international%20certification%20layout%2C%20quality%20management%20symbols%2C%20professional%20corporate%20document%20style%20with%20official%20seals&width=300&height=400&seq=cert-iso&orientation=portrait',
      description: '通过国际食品安全管理体系认证，确保产品质量安全',
      icon: 'ri-shield-check-line',
      color: 'text-blue-600'
    },
    {
      id: 4,
      title: '地理标志产品保护',
      issuer: '国家知识产权局',
      date: '2023年8月',
      image: 'https://readdy.ai/api/search-image?query=Geographic%20indication%20protection%20certificate%20for%20Pu-er%20tea%20with%20official%20Chinese%20government%20seal%2C%20traditional%20map%20elements%2C%20golden%20tea%20plantation%20background%2C%20formal%20certificate%20design%20with%20red%20ribbons&width=300&height=400&seq=cert-geographic&orientation=portrait',
      description: '普洱茶地理标志产品保护认证，保障原产地品质',
      icon: 'ri-map-pin-line',
      color: 'text-amber-600'
    },
    {
      id: 5,
      title: '非物质文化遗产传承',
      issuer: '云南省文化厅',
      date: '2023年6月',
      image: 'https://readdy.ai/api/search-image?query=Intangible%20cultural%20heritage%20certificate%20with%20traditional%20Chinese%20cultural%20patterns%2C%20ancient%20tea%20making%20tools%20illustration%2C%20vintage%20parchment%20style%20with%20calligraphy%2C%20cultural%20protection%20official%20seal&width=300&height=400&seq=cert-heritage&orientation=portrait',
      description: '传统制茶工艺被认定为非物质文化遗产，传承古法技艺',
      icon: 'ri-ancient-gate-line',
      color: 'text-purple-600'
    },
    {
      id: 6,
      title: '企业信用AAA级认证',
      issuer: '中国企业信用评价中心',
      date: '2024年2月',
      image: 'https://readdy.ai/api/search-image?query=Triple%20A%20credit%20rating%20certificate%20with%20gold%20AAA%20letters%2C%20professional%20business%20certificate%20design%2C%20trust%20and%20reliability%20symbols%2C%20corporate%20excellence%20award%20style%20with%20blue%20and%20gold%20colors&width=300&height=400&seq=cert-credit&orientation=portrait',
      description: '获得企业信用最高等级认证，诚信经营典范',
      icon: 'ri-medal-line',
      color: 'text-yellow-600'
    }
  ];

  return (
    <section className="py-12 lg:py-16 bg-white">
      <div className="px-6 lg:px-16">
        <div className="text-center mb-8 lg:mb-12">
          <h2 className="text-2xl lg:text-3xl font-bold text-primary font-serif mb-3">
            权威认证
          </h2>
          <p className="text-base text-gray-600 max-w-2xl mx-auto">
            多项国际国内权威认证，见证马帮瑞贡卓越品质与诚信经营
          </p>
        </div>

        <div className="grid grid-cols-2 lg:grid-cols-3 gap-4 lg:gap-8">
          {certifications.map((cert) => (
            <div
              key={cert.id}
              className="group bg-gray-50 rounded-xl p-4 lg:p-6 hover:shadow-lg transition-all duration-300 hover:scale-105 border border-gray-100"
            >
              <div className="relative mb-3 lg:mb-4">
                <img
                  src={cert.image}
                  alt={cert.title}
                  className="w-full h-32 lg:h-48 object-cover rounded-lg"
                />
                <div className="absolute top-2 lg:top-3 right-2 lg:right-3 w-8 h-8 lg:w-10 lg:h-10 bg-white/90 rounded-full flex items-center justify-center backdrop-blur-sm">
                  <i className={`${cert.icon} text-sm lg:text-lg ${cert.color}`}></i>
                </div>
              </div>
              
              <h3 className="text-sm lg:text-lg font-bold text-primary font-serif mb-2 group-hover:text-accent transition-colors duration-300">
                {cert.title}
              </h3>
              
              <div className="flex items-center justify-between text-xs text-gray-500 mb-2 lg:mb-3">
                <span className="truncate pr-1">{cert.issuer}</span>
                <span className="flex-shrink-0">{cert.date}</span>
              </div>
              
              <p className="text-xs lg:text-sm text-gray-600 leading-relaxed">
                {cert.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default CertificationGrid;
